import React from 'react';
import ReactDOM from 'react-dom/client';

import { initFirebaseAuth } from './shared/firebase/init';
import { App } from './shell/App';
import { setupServiceWorker } from './shell/registerSW';

import './index.css';

// M3.3 — Bootstrap mínimo:
//   1. Apenas Camada 1 do Firebase (app + auth) é inicializada aqui.
//      Firestore / Functions / Storage chegam apenas com /app/* via lazy.
//   2. Service Worker registra cedo para PWA cobrir o primeiro navigate.
//   3. `purgeExpiredCoordinates()` é importado dinamicamente abaixo —
//      depende de `firebase/firestore` (Timestamp) e iria furar a camada 1
//      se fosse import estático.
initFirebaseAuth();
setupServiceWorker();

void import('./shared/local/coordinates').then(({ purgeExpiredCoordinates }) =>
  purgeExpiredCoordinates().catch((e) => console.warn('purge coords failed', e)),
);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemento raiz #root não encontrado no documento.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
